import { render, staticRenderFns } from "./CourseCard.vue?vue&type=template&id=4188c406&scoped=true&"
import script from "./CourseCard.vue?vue&type=script&lang=ts&"
export * from "./CourseCard.vue?vue&type=script&lang=ts&"
import style0 from "./CourseCard.vue?vue&type=style&index=0&id=4188c406&prod&lang=css&"
import style1 from "./CourseCard.vue?vue&type=style&index=1&id=4188c406&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4188c406",
  null
  
)

export default component.exports